/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Source_OnceInputs */

const vi_irrigation_run_source_once = /** @type {(inputs: Irrigation_Run_Source_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hẹn giờ`)
};

/**

* @param {Irrigation_Run_Source_OnceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_source_once = /** @type {((inputs?: Irrigation_Run_Source_OnceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Source_OnceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_source_once(inputs)
});